import React, { useState, useEffect } from 'react';
import API_URL from '../config';

const camposConfig = [
  'rev_whatsapp', 'rev_nome_app', 'rev_cor_primaria', 'ativo', 'rev_validade', 'rev_carencia',
  'rev_icone_app', 'rev_icone_splash', 'rev_icone_grupo', 'rev_icone_produto', 'rev_icone_cliente',
  'rev_icone_consulta', 'rev_icone_agenda', 'rev_icone_pedido', 'rev_icone_atend', 'rev_icone_pix',
  'rev_icone_dashboard', 'rev_icone_informacoes', 'rev_icone_st01', 'rev_icone_st02'
];

const camposIcone = [
  'rev_icone_app', 'rev_icone_splash', 'rev_icone_grupo', 'rev_icone_produto', 'rev_icone_cliente',
  'rev_icone_consulta', 'rev_icone_agenda', 'rev_icone_pedido', 'rev_icone_atend', 'rev_icone_pix',
  'rev_icone_dashboard', 'rev_icone_informacoes', 'rev_icone_st01', 'rev_icone_st02'
];

function maskTelefone(value) {
  value = value.replace(/\D/g, '');
  if (value.length <= 10) {
    value = value.replace(/(\d{2})(\d)/, '($1)$2');
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    value = value.replace(/(\d{2})(\d)/, '($1)$2');
    value = value.replace(/(\d{5})(\d)/, '$1-$2');
  }
  return value;
}

// Função utilitária para exibir imagem (igual RevendaEmpresasPage.js)
function getImagemUrl(path) {
  if (!path) return '';
  if (path.startsWith('https://')) return path;
  return `https://conexaopix.com.br/docs${path}`;
}

const RevendaConfiguracaoPage = ({ empresa, onClose }) => {
  const [form, setForm] = useState({
    id: empresa.id,
    rev_whatsapp: empresa.rev_whatsapp || '',
    rev_nome_app: empresa.rev_nome_app || '',
    rev_cor_primaria: empresa.rev_cor_primaria || '',
    ativo: empresa.ativo !== undefined ? empresa.ativo : true,
    rev_validade: empresa.rev_validade || '',
    rev_carencia: empresa.rev_carencia || '',
    rev_icone_app: empresa.rev_icone_app || '',
    rev_icone_splash: empresa.rev_icone_splash || '',
    rev_icone_grupo: empresa.rev_icone_grupo || '',
    rev_icone_produto: empresa.rev_icone_produto || '',
    rev_icone_cliente: empresa.rev_icone_cliente || '',
    rev_icone_consulta: empresa.rev_icone_consulta || '',
    rev_icone_agenda: empresa.rev_icone_agenda || '',
    rev_icone_pedido: empresa.rev_icone_pedido || '',
    rev_icone_atend: empresa.rev_icone_atend || '',
    rev_icone_pix: empresa.rev_icone_pix || '',
    rev_icone_dashboard: empresa.rev_icone_dashboard || '',
    rev_icone_informacoes: empresa.rev_icone_informacoes || '',
    rev_icone_st01: empresa.rev_icone_st01 || '',
    rev_icone_st02: empresa.rev_icone_st02 || '',
  });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [uploading, setUploading] = useState({});

  // Buscar dados atualizados ao abrir o modal
  useEffect(() => {
    async function fetchEmpresa() {
      try {
        const res = await fetch(`${API_URL}/pessoas/${empresa.id}`);
        if (res.ok) {
          const data = await res.json();
          setForm({
            id: data.id,
            rev_whatsapp: data.rev_whatsapp || '',
            rev_nome_app: data.rev_nome_app || '',
            rev_cor_primaria: data.rev_cor_primaria || '',
            ativo: data.ativo !== undefined ? data.ativo : true,
            rev_validade: data.rev_validade || '',
            rev_carencia: data.rev_carencia || '',
            rev_icone_app: data.rev_icone_app || '',
            rev_icone_splash: data.rev_icone_splash || '',
            rev_icone_grupo: data.rev_icone_grupo || '',
            rev_icone_produto: data.rev_icone_produto || '',
            rev_icone_cliente: data.rev_icone_cliente || '',
            rev_icone_consulta: data.rev_icone_consulta || '',
            rev_icone_agenda: data.rev_icone_agenda || '',
            rev_icone_pedido: data.rev_icone_pedido || '',
            rev_icone_atend: data.rev_icone_atend || '',
            rev_icone_pix: data.rev_icone_pix || '',
            rev_icone_dashboard: data.rev_icone_dashboard || '',
            rev_icone_informacoes: data.rev_icone_informacoes || '',
            rev_icone_st01: data.rev_icone_st01 || '',
            rev_icone_st02: data.rev_icone_st02 || '',
          });
        }
      } catch {}
    }
    fetchEmpresa();
  }, [empresa.id]);

  // Aplica a máscara ao valor inicial do WhatsApp
  useEffect(() => {
    setForm(f => ({ ...f, rev_whatsapp: maskTelefone(f.rev_whatsapp) }));
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'rev_whatsapp') {
      setForm(prev => ({
        ...prev,
        [name]: maskTelefone(value)
      }));
    } else if (name === 'rev_validade') {
      setForm(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    }
  };

  // Upload EXATAMENTE igual GruposPage.js
  const handleIconeUpload = async (e, campo) => {
    const file = e.target.files[0];
    if (!file) return;
    setErro('');
    setUploading(u => ({ ...u, [campo]: true }));
    const formData = new FormData();
    formData.append('file', file);
    formData.append('revenda_id', form.id);
    try {
      const res = await fetch(`${API_URL}/upload-empresa-logo`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Erro ao fazer upload');
      const data = await res.json();
      const urlCompleta = data.path.startsWith('https://') ? data.path : `https://conexaopix.com.br/docs${data.path}`;
      setForm(f => ({ ...f, [campo]: urlCompleta }));
    } catch (err) {
      setErro('Erro ao fazer upload do ícone');
    }
    setUploading(u => ({ ...u, [campo]: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro('');
    // Enviar apenas campos alterados
    const camposAlterados = {};
    camposConfig.forEach((campo) => {
      if (form[campo] !== (empresa[campo] || (campo === 'ativo' ? true : ''))) {
        camposAlterados[campo] = form[campo];
      }
    });
    if (Object.keys(camposAlterados).length === 0) {
      setErro('Nenhuma alteração detectada.');
      setLoading(false);
      return;
    }
    try {
      const res = await fetch(`${API_URL}/pessoas/${form.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(camposAlterados),
      });
      if (!res.ok) throw new Error('Erro ao atualizar configuração');
      onClose();
    } catch (err) {
      setErro('Erro ao salvar configuração');
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl relative border border-blue-200 font-sans">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
        <h2 className="text-xl font-bold text-blue-700 mb-6">Configuração da Revenda</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp</label>
              <input type="text" name="rev_whatsapp" value={form.rev_whatsapp} onChange={handleChange} maxLength={15} placeholder="(99)99999-9999" className="border rounded px-3 py-2 w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nome App</label>
              <input type="text" name="rev_nome_app" value={form.rev_nome_app} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Cor Primária</label>
              <input type="color" name="rev_cor_primaria" value={form.rev_cor_primaria || '#000000'} onChange={handleChange} className="border rounded w-12 h-12 p-0" />
              <span className="ml-2 text-xs">{form.rev_cor_primaria}</span>
            </div>
            <div className="flex items-center gap-2 mt-6">
              <input type="checkbox" name="ativo" checked={form.ativo} disabled className="mt-1" />
              <label className="block text-sm font-medium text-gray-700">Ativo</label>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Validade</label>
              <input type="date" name="rev_validade" value={form.rev_validade ? form.rev_validade.slice(0,10) : ''} disabled className="border rounded px-3 py-2 w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Carência</label>
              <input type="number" name="rev_carencia" value={form.rev_carencia} disabled className="border rounded px-3 py-2 w-full" />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
            {camposIcone.map(campo => {
              let label = campo.replace('rev_icone_', '').replace('_', ' ').toUpperCase();
              if (campo === 'rev_icone_informacoes') label = 'INFORMAÇÕES';
              if (campo === 'rev_icone_st01') label = 'MobTEF 01';
              if (campo === 'rev_icone_st02') label = 'MobTEF 02';
              return (
              <div key={campo}>
                  <label className="block text-xs font-medium text-gray-700 mb-1">{label}</label>
                  <input type="file" accept="image/*" name={campo} onChange={e => handleIconeUpload(e, campo)} className="border rounded px-2 py-1 w-full text-xs" disabled={uploading[campo]} />
                {form[campo] && (
                    <div className="mt-2 flex items-center">
                      <img src={getImagemUrl(form[campo])} alt={campo} className="w-12 h-12 object-contain rounded border shadow bg-gray-50" />
                    </div>
                )}
                {uploading[campo] && <span className="text-xs text-gray-500">Enviando...</span>}
              </div>
              );
            })}
          </div>
          {erro && <div className="text-red-600 mb-2 font-semibold text-center">{erro}</div>}
          <div className="flex justify-end space-x-2 mt-6">
            <button type="button" onClick={onClose} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
            <button type="submit" disabled={loading} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RevendaConfiguracaoPage; 